function convertSizeToFileBytes(size: number, unit: string) {
  let bytes = 0;
  switch (unit) {
    case "KB":
      bytes = size * 1024;
      break;
    case "MB":
      bytes = size * 1024 * 1024;
      break;
    default:
      throw new Error("Invalid size unit");
  }

  return bytes;
}

export function validateDocuments(
  documentConfigList: Record<string, unknown>,
  formData: Record<string, any>,
  userType?: string
): { valid: true } | { valid: false; message: string } {
  try {
    let keysToVerify: { key: string; label: string }[] = [];
    switch (formData?.user_type) {
      case "Engineer": {
        keysToVerify = [
          {
            key: "gov_id_document",
            label: formData?.document_type || "Government ID",
          },
          { key: "document_certificate", label: "Degree Certificate" },
          { key: "licence_certificate", label: "Engineer License Certificate" },
        ];

        break;
      }
      case "Architect": {
        keysToVerify = [
          {
            key: "gov_id_document",
            label: formData?.document_type || "Government ID",
          },
          { key: "document_certificate", label: "Degree Certificate" },
          {
            key: "licence_certificate",
            label: "Architect License Certificate",
          },
        ];
        break;
      }
      case "Supervisor": {
        keysToVerify = [
          {
            key: "gov_id_document",
            label: formData?.document_type || "Government ID",
          },
          {
            key: "document_certificate",
            label: "Highest Education Certificate",
          },
          { key: "experience_certificate", label: "Experience Certificate" },
        ];
        break;
      }
      default: {
        keysToVerify = [
          {
            key: "gov_id_document",
            label: formData?.document_type || "Government ID",
          },
        ];
      }
    }

    const hit = keysToVerify.find((doc) => !formData?.[doc.key]);

    if (hit) {
      return { valid: false, message: `Please upload ${hit.label}` };
    }

    if (
      documentConfigList?.file_size &&
      typeof documentConfigList?.file_size === "number" &&
      documentConfigList?.file_size_unit
    ) {
      const sizeInBytes = convertSizeToFileBytes(
        documentConfigList.file_size,
        String(documentConfigList.file_size_unit)
      );

      if (
        formData.gov_id_document &&
        sizeInBytes < formData.gov_id_document.size
      ) {
        return {
          valid: false,
          message: `${formData.document_type}: Please upload Document less than ${documentConfigList.file_size}${documentConfigList.file_size_unit}`,
        };
      }
      if (
        formData.document_certificate &&
        sizeInBytes < formData.document_certificate.size
      )
        return {
          valid: false,
          message: `Degree Certificate: Please upload Document less than ${documentConfigList.file_size}${documentConfigList.file_size_unit}`,
        };
      if (
        formData.licence_certificate &&
        sizeInBytes < formData.licence_certificate.size
      )
        return {
          valid: false,
          message: `License Certificate: Please upload Document less than ${documentConfigList.file_size}${documentConfigList.file_size_unit}`,
        };

      if (
        formData.experience_certificate &&
        sizeInBytes < formData.experience_certificate.size
      )
        return {
          valid: false,
          message: `License Certificate: Please upload Document less than ${documentConfigList.file_size}${documentConfigList.file_size_unit}`,
        };
    }

    return { valid: true };
  } catch (err) {
    return { valid: false, message: "Validation error!" };
  }
}
